import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import cat from '../images/collection/1.png';

const Animations = () => {
    return (
        <div className="w-full">
            <Header />
            <div className="w-full bg-[#FEEEDE] flex flex-col items-center gap-10 py-12 px-4 overflow-hidden">
                <img src={cat} alt="Lilverse character" className="w-[220px] md:w-[300px]" />
                <div className="text-center">
                    <h1 className="font-dang text-[#FE9ECE] text-with-border text-[10vw] md:text-[4vw] leading-tight">Lilverse animations</h1>
                    <p className="font-mons text-lg md:text-2xl mt-4 max-w-2xl mx-auto">We show the world from a different angle.</p>
                    <p className="font-mons text-lg md:text-2xl max-w-2xl mx-auto">Dive into a world filled with fun and love. It can make your day.</p>
                </div>
                <div className="flex flex-wrap justify-center gap-4 max-w-4xl">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <img key={i} src={cat} alt="Lilverse character" className="w-[110px] md:w-[150px]" />
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Animations;
